import { useMemo } from "react";

import { useBalanceQuery } from "@bentolabs/kit/hooks";
import { formatCurrency } from "@bentolabs/kit/web3";
import { useChainId } from "wagmi";

import { bentoUSDConfig, bentoUSDPlusConfig } from "shared/config/const";
import { plus } from "shared/utils";

import { useUsdRate } from "./use-usd-rate";

export const useTotalBalance = () => {
  const chainId = useChainId();

  const bento = bentoUSDConfig[chainId];
  const bentoPlus = bentoUSDPlusConfig[chainId];

  const bentoBalanceQuery = useBalanceQuery({ currency: bento });
  const bentoBalance = bentoBalanceQuery.data;
  const bentoPlusBalanceQuery = useBalanceQuery({ currency: bentoPlus });
  const bentoPlusBalance = bentoPlusBalanceQuery.data;

  const bentoAmount = useUsdRate(bento, bentoBalance?.formatted);
  const bentoPlusAmount = useUsdRate(bento, bentoPlusBalance?.formatted);

  return useMemo(() => {
    if (!bentoAmount || !bentoPlusAmount) return;

    return formatCurrency(plus(bentoAmount, bentoPlusAmount).toString());
  }, [bentoAmount, bentoPlusAmount]);
};
